import { ProgramType } from 'fitbeat.models';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme, { ThemeType } from '../../theme';
import { ChevronRightIcon, Tile } from '../../ui';
import { mappedIcons, mappedTitles } from '../../WorkoutGoalAssistant';
import { defaultScale } from '../../utils/scaling';

interface IProps {
  icon?: any;
  programType: ProgramType;
  useInline: boolean;
  theme?: ThemeType;
  currentSelectedGoal?: any;
  shouldHightLightSelected?:boolean;
  useBackgroundForGoalHeader?: boolean;
  onPress?(): void;
}

export const LongTermGoalTile = ({
  currentSelectedGoal,
  programType,
  onPress,
  useInline = false,
  shouldHightLightSelected = false,
  theme = ThemeType.dark,
  useBackgroundForGoalHeader = false }: IProps) => {
  const isCurrentGoal = currentSelectedGoal === mappedTitles[programType] ;
  const markAsSelected = isCurrentGoal && shouldHightLightSelected;
  const themeStyle = markAsSelected ? themeStyleMapper[ThemeType.dark] : themeStyleMapper[theme];
  const backgroundColor = markAsSelected ? themeStyleMapper[ThemeType.dark].backgroundColor : (!useInline && !useBackgroundForGoalHeader) ? 'transparent' : themeStyle.backgroundColor;
  return (
    <Tile
      customStyle={[styles.tile, themeStyle, useInline && styles.inlineTile, { backgroundColor }]}
      onPress={onPress}>
      <View style={[useInline && styles.inlineInnerContainer]}>
        <View style={styles.iconContainer}>{mappedIcons[programType]({}, themeStyle.color)}</View>
        <Text style={[styles.goalTitle, { color: themeStyle.color }]}>{mappedTitles[programType].toUpperCase()}</Text>
      </View>
      {onPress &&
        <View style={styles.chevronContainer}>
          <View style={{ paddingLeft: defaultScale(10) }}>
            <ChevronRightIcon width={defaultScale(18)} height={defaultScale(18)} color={Theme.PRIMARY} />
          </View>
        </View>
      }
    </Tile>
  );
};

const themeStyleMapper = {
  [ThemeType.light]: {
    backgroundColor: Theme.WHITE,
    borderColor: Theme.GREY_MEDIUM_LIGHT,
    color: Theme.CHARCOAL,
  },
  [ThemeType.dark]: {
    backgroundColor: Theme.CHARCOAL,
    borderColor: Theme.GREY_DARK_MEDIUM,
    color: Theme.WHITE,
  },
};

const styles = StyleSheet.create({
  tile: {
    height: defaultScale(100),
    paddingVertical: defaultScale(10),
    paddingRight: defaultScale(10),
    paddingLeft: defaultScale(20),
    borderRadius: 0,
    marginBottom: defaultScale(20),
    borderWidth: 0,
    borderBottomWidth: defaultScale(1),
    flexDirection: 'column',
  },
  inlineTile: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: defaultScale(5),
    borderWidth: defaultScale(1),
  },
  inlineInnerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  textContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  goalTitle: {
    ...Theme.textStyle.heading,
    paddingRight: defaultScale(5),
    color: Theme.WHITE,
    textAlign: 'center',
  },
  iconContainer: {
    width: defaultScale(40),
    height: defaultScale(40),
    marginBottom: defaultScale(10),
    marginRight: defaultScale(10),
    alignSelf: 'center',
  },
  chevronContainer: {
    height: '100%',
    marginRight: defaultScale(5),
    borderLeftWidth: defaultScale(0.5),
    borderColor: Theme.GREY_DARK_MEDIUM,
    justifyContent: 'center',
  },
});
